import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const HLSVideo = ({ src, ...props }) => {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (src.endsWith('.m3u8')) {
      if (Hls.isSupported()) {
        hlsRef.current = new Hls();
        hlsRef.current.loadSource(src);
        hlsRef.current.attachMedia(video);
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src;
        video.addEventListener('loadedmetadata', () => {
          video.play().catch(err => console.error('자동 재생 실패:', err));
        });
      }
    } else {
      video.src = src;
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
    };
  }, [src]);

  return (
    <video ref={videoRef} {...props}>
      {!src.endsWith('.m3u8') && <source src={src} type="video/mp4" />}
    </video>
  );
};

export default HLSVideo;